module.exports = __webpack_public_path__ + "img/case_bottom_006.cf296bd4.png";